import { listClasses } from '@mui/material/List';
import type { Components, Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

const MuiPopover: Components<Theme>['MuiPopover'] = {
  /** **************************************
   * DEFAULT PROPS
   *************************************** */
  defaultProps: { disableScrollLock: true },

  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    paper: ({ theme }) => ({
      ...theme.mixins.paperStyles(theme, { dropdown: true }),
      backgroundImage: 'none',
      backgroundColor: theme.vars.palette.background.paper,
      [`& .${listClasses.root}`]: { paddingTop: 0, paddingBottom: 0 },
      '& > span': {
        backgroundImage: 'none',
        backgroundColor: theme.vars.palette.background.paper,
      },
    }),
  },
};

// ----------------------------------------------------------------------

export const popover = { MuiPopover };
